import React from "react";
import "./Contact.css";

export default function ContactPage() {
  return (
    <div className="contact-container">
      <h1 className="contact-title">Contact Us</h1>

      <div className="contact-grid">
        {/* Contact Form */}
        <div className="contact-form">
          <h2>Get in Touch</h2>
          <form>
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <textarea placeholder="Your Message" required></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>
        </div>
        <br></br>

        {/* Contact Details */}
        <div className="contact-details">
          <p><strong>Address:</strong> Sri Amman Sweets, Sathya Nagar, Gopalapuram, P.N.Palayam (T.K), Salem Dt-636938</p>
          <p><strong>Phone:</strong> +91 7010490133, +91 8637491264</p>
          <p><strong>Email:</strong> sriammansweets@gmail.com</p>

          {/* Google Maps Embed */}
          <iframe
            className="contact-map"
            src="https://www.google.com/maps/embed?..."
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </div>
    
  );
}
